export default __webpack_public_path__ + "Send-request-Icon.svg";